// Rumus System HPP (identik dengan backend routers/hpp.py compute_hpp)
export const sumRows = (rows) => (rows || []).reduce((a, r) => a + (Number(r.nilai) || 0), 0);

export function computeHpp(sim) {
  const totalModal = sumRows(sim.capex);
  const totalOpex = sumRows(sim.opex);
  const hppDasar = sumRows(sim.variabel);
  const volume = Number(sim.volume) || 0;
  const margin = Number(sim.margin_persen) || 0;
  const hppTotal = hppDasar + (volume > 0 ? totalOpex / volume : 0);
  const rekomendasi = hppTotal + (hppTotal * margin) / 100;
  const hasAktual = sim.harga_aktual !== null && sim.harga_aktual !== undefined && sim.harga_aktual !== "";
  const harga = hasAktual ? Number(sim.harga_aktual) || 0 : rekomendasi;
  const bep = (price) => {
    const lu = price - hppTotal;
    if (volume <= 0 || lu <= 0) return null;
    return totalModal / (lu * volume);
  };
  return {
    totalModal, totalOpex, hppDasar, hppTotal, rekomendasi, volume,
    bep: bep(rekomendasi), harga, hasAktual,
    marginAktual: hppTotal > 0 ? ((harga - hppTotal) / hppTotal) * 100 : null,
    bepAktual: bep(harga),
    labaUnit: harga - hppTotal, labaBulanan: (harga - hppTotal) * volume, omzetBulanan: harga * volume,
  };
}

export const fmtBulan = (v) =>
  v === null || v === undefined ? "—" : `${Number(v).toLocaleString("id-ID", { maximumFractionDigits: 1 })} bulan`;
export const fmtPersen = (v) =>
  v === null || v === undefined ? "—" : `${Number(v).toLocaleString("id-ID", { maximumFractionDigits: 2 })}%`;
